export default "__VITE_ASSET__zvsQeYUm__"